<!--可以不断往右边扩展的列表选择组件-->
<template>
	<div class="selectionBody" @click.stop="nowItem = undefined">
		<ul class="hideBar list-body">
			<li v-for="item in dataList" class="flexBetween" @mouseenter="nowItem = item" @click.stop="checkItem(item)" :title="getNameMethod(item)">
				<p class="info-body">{{getNameMethod(item)}}</p>
				<img class="next-ico" v-show="hasNext(item) " :src="getRightArrow(hasNext(item))">
			</li>
		</ul>
		<listSelection v-if="hasNext(nowItem)" :dataList="nowItem.next" @checkItem="$emit('checkItem',$event),nowItem = undefined"
		 :targetMethod="targetMethod" :getNameMethod="getNameMethod"></listSelection>
	</div>

</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		name: "listSelection",
		components: {},
		props: {
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			getNameMethod: {
				type: Function,
				default (item) {
					if (item == undefined) {
						return ''
					}
					return item.name
				}
			},
			targetMethod: {
				type: Function,
				default (item) {
					//用来判定点击的项是不是想要的选中项的方法
					return !this.hasNext(item)
				}
			}
		},
		data() {
			return {
				nowItem: undefined
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			hasNext() {
				return item => {
					return item != undefined && item.next != undefined
				}
			}
		},
		watch: {
			dataList(nv, ov) {
				this.nowItem = undefined
			}
		},
		methods: {
			getRightArrow(hasNext) {
				if (hasNext) {
					return resourcesStore.getters.getResourcesByName("/arrow/right_arrow.svg")
				}
				return ''
			},
			checkItem(item) {
				if (this.targetMethod(item)) {
					this.$emit('checkItem', item)
				}
			}
		}
	}
</script>

<style scoped>

	.selectionBody {
		display: inline-flex;
		justify-content: flex-start;
		height: 2rem;
		background: white;
	}

	.selectionBody>.hideBar {
		width: 200px;
		height: 100%;
	}
</style>
